import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { LocalStoreService } from 'src/app/shared/services/local-store.service';

@Component({
  selector: 'app-auth-layout',
  templateUrl: './auth-layout.component.html',
})
export class AuthLayoutComponent implements OnInit {
  constructor(
    public translate: TranslateService,
    private loader: NgxUiLoaderService,
    private local: LocalStoreService
  ) {
    // Translator init
    const currentLang = this.local.getItem('lang');
    if (currentLang)
      translate.use(
        currentLang.code.match(/en|fr|vi/) ? currentLang.code : 'vi'
      );
  }

  ngOnInit() {}
}
